import Vue from "vue";
import Vuex from "vuex";
import firebase from "firebase";
import createPersistedState from "vuex-persistedstate";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    categories: [],
    menus: [],
    selectedCategory: "",
    localeEn: false,
    errorFlag: false
  },
  mutations: {
    setCategories(state, payload) {
      state.categories = payload.categories;
    },
    setMenus(state, payload) {
      state.menus = payload.menus;
    },
    setSelectedCategory(state, payload) {
      state.selectedCategory = payload.selectedCategory;
    },
    changeLocale(state) {
      state.localeEn = !state.localeEn;
    },
    changeLocaleJa(state) {
      state.localeEn = false;
    },
    changeLocaleEn(state) {
      state.localeEn = true;
    },
    successErrorFlag(state) {
      state.errorFlag = false;
    },
    failureErrorFlag(state) {
      state.errorFlag = true;
    }
  },
  actions: {
    createCategories({
      commit
    }, {
      id
    }) {
      let category = new Object;
      let categories = new Array;

      firebase
        .firestore()
        .collection("Users")
        .doc(id)
        .collection("Categories")
        .get()
        .then((snapshot) => {
          if (snapshot.empty === false) {
            commit("successErrorFlag");
            snapshot.forEach((doc) => {
              category = doc.data();
              category["id"] = doc.id;
              categories.push(category);
            });
            commit("setCategories", {
              categories: categories,
            });
            commit("setSelectedCategory", {
              selectedCategory: categories.find(
                (element) => element.sortNum === 0
              ).id,
            });
          } else {
            commit("failureErrorFlag");
            category["id"] = "";
            category["name_en"] = "";
            category["name_jp"] = "";
            category["sortNum"] = 0;
            categories.push(this.category);
            commit("setCategories", {
              categories: this.categories,
            });
          }
        });
    },
    createPosts({
      commit
    }, {
      id
    }) {
      let menus = new Array;

      firebase
        .firestore()
        .collection("Users")
        .doc(id)
        .collection("Posts")
        .orderBy('sortNum')
        .get()
        .then((snapshot) => {
          snapshot.forEach((doc) => {
            menus.push(doc.data());
          });
          commit("setMenus", {
            menus: menus
          });
        });
    }
  },
  plugins: [createPersistedState({
    storage: window.sessionStorage
  })],
});